// src/components/intake/IntakeAutonomo.js
//
// Ticket 064 (screen 2.4, D9). The autónomo facts form, shown only when the
// person's own self-employment card exists. It wraps the unedited
// AutonomoFactsForm and starts from NULL values (not createEmptyAutonomoFacts(),
// which pre-fills 'individual' and would store a guess, rule 7).

import React from 'react'
import AutonomoFactsForm from '../../pages/AutonomoFactsForm'

export default function IntakeAutonomo({ autonomo, onChange }) {
  return <AutonomoFactsForm facts={autonomo} onChange={onChange} />
}
